// Owner: record-create-mobile (wave 2); registry conversion by ui-layers. Global record dialogs opened
// from any screen: `openCreateRecord()` → `record-create` (src/features/records/events.ts). Their code loads on first open.
import { lazy } from 'react';
import { defineGlobalLayer } from '../shell/overlays';

export default [
  defineGlobalLayer({
    id: 'record-create',
    component: lazy(() => import('./record-overlays.layer').then((m) => ({ default: m.CreateRecordLayer }))),
  }),
];
